<template>
  <section class="menu-business" :class="{ 'open' : open }">
    <div class="menu-header">
      <div @click="push('/')" class="menu-logo">
        <Logo />
      </div>
      <div @click="open = !open" class="menu-icon">
        <transition name="pop" mode="out-in">
          <i v-if="open" class="fas fa-times"></i>
          <i v-else class="fas fa-bars"></i>
        </transition>
      </div>
    </div>
    <div class="menu-items">
      <div v-if="business && business.profile.indexOf('dashboard') > -1" @click="push('/dashboard')" class="menu-item" :class="{ 'active' : isRoute('/dashboard') }">
        <i class="fas fa-chart-line"></i>
        <span>Dashboard</span>
      </div>
      <div v-if="business && business.profile.indexOf('show') > -1" @click="push('/event')" class="menu-item" :class="{ 'active' : isRoute('/event') }">
        <i class="far fa-calendar-alt"></i>
        <span>Eventos</span>
      </div>
      <div v-if="business && business.profile.indexOf('showcase') > -1" @click="push('/showcase')" class="menu-item" :class="{ 'active' : isRoute('/showcase') }">
        <i class="fas fa-object-group"></i>
        <span>Vitrine</span>
      </div>
      <div v-if="business && business.profile.indexOf('show') > -1" @click="push('/festival')" class="menu-item" :class="{ 'active' : isRoute('/festival') }">
        <i class="far fa-calendar-alt"></i>
        <span>Festival</span>
      </div>
      <div v-if="(business && business.profile.indexOf('ticket') > -1) || (user.role !== 'producer' && business.profile.indexOf('sellOnlyReserved') > -1)" @click="push('/ticket')" class="menu-item" :class="{ 'active' : isRoute('/ticket') }">
        <i class="fas fa-ticket-alt"></i>
        <span>Bilheteria</span>
      </div>
      <div v-if="(business && business.profile.indexOf('validator') > -1) || user.role === 'producer'" @click="push('/validator')" class="menu-item" :class="{ 'active' : isRoute('/validator') }">
        <i class="fas fa-tasks"></i>
        <span>Validador</span>
      </div>
      <div v-if="(business && business.profile.indexOf('bordero') > -1) || user.role === 'producer'" @click="push('/bordero')" class="menu-item" :class="{ 'active' : isRoute('/bordero') }">
        <i class="fas fa-file-medical-alt"></i>
        <span>Borderôs</span>
      </div>
      <div v-if="business && business.profile.indexOf('ticket-sale') > -1" @click="push('/sales')" class="menu-item" :class="{ 'active' : isRoute('/sales') }">
        <i class="fas fa-dollar-sign"></i>
        <span>Vendas</span>
      </div>
      <!-- <div v-if="business && business.profile.indexOf('financial') > -1" @click="push('/financial')" class="menu-item" :class="{ 'active' : isRoute('/financial') }">
        <i class="fas fa-money-check-alt"></i>
        <span>Financeiro</span>
      </div> -->
      <div v-if="business && business.profile.indexOf('ticket-type') > -1" @click="push('/ticket-type')" class="menu-item" :class="{ 'active' : isRoute('/ticket-type') }">
        <i class="fas fa-clipboard-list"></i>
        <span>Tipos de Ingresso</span>
      </div>
      <div v-if="business && business.profile.indexOf('ticket-book') > -1" @click="push('/ticket-book')" class="menu-item" :class="{ 'active' : isRoute('/ticket-book') }">
        <i class="fas fa-book"></i>
        <span>Reservas</span>
      </div>
      <div v-if="business && business.profile.indexOf('user') > -1" @click="push('/usuario')" class="menu-item" :class="{ 'active' : isRoute('/usuario') }">
        <i class="fas fa-users"></i>
        <span>Usuários</span>
      </div>
      <div v-if="business && business.profile.indexOf('settings') > -1" @click="push('/settings')" class="menu-item" :class="{ 'active' : isRoute('/settings') }">
        <i class="fas fa-cog"></i>
        <span>Configurações</span>
      </div>
      <div v-if="business && business.profile.indexOf('educational') > -1" @click="push('/educational-video')" class="menu-item" :class="{ 'active' : isRoute('/educational-video') }">
        <i class="fas fa-graduation-cap"></i>
        <span>Educacional</span>
      </div>
      <div v-if="business && business.profile.indexOf('info') > -1" @click="push('/info')" class="menu-item" :class="{ 'active' : isRoute('/info') }">
        <i class="fas fa-info-circle"></i>
        <span>Informações</span>
      </div>
      <div v-if="business && business.profile.indexOf('financial') > -1 && business.split" @click="push('/finances')" class="menu-item" :class="{ 'active' : isRoute('/finances') }">
        <i class="fas fa-money-check-alt"></i>
        <span>Portal Financeiro</span>
      </div>
      <div v-if="(business && business.profile.indexOf('invitation') > -1) || user.role === 'producer'" @click="push('/invitation')" class="menu-item" :class="{ 'active' : isRoute('/invitation') }">
        <i class="fas fa-gift"></i>
        <span>Convites</span>
      </div>
      <!-- <div v-if="(business && business.profile.indexOf('show') > -1)" @click="push('/producer')" class="menu-item" :class="{ 'active' : isRoute('/producer') }">
        <i class="fas fa-user-tie"></i>
        <span>Produtores</span>
      </div> -->
    </div>
    <div>
      <div @click="signOut" class="menu-item">
        <i class="fas fa-sign-out-alt"></i>
        <span>Sair</span>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import { removeToken, loadModule } from '../../util'
import Logo from './Logo.vue'

export default {
  components: {
    Logo
  },
  name: 'Menu',
  data () {
    return {
      open: false
    }
  },
  computed: {
    ...mapState(['user', 'business'])
  },
  methods: {
    async push (path) {
      this.open = false
      await this.$router.push(path)
    },
    isRoute (path) {
      if (this.$route.path.split('/')[1] === path.split('/')[1]) return true
      // if (this.$route.path.includes(path)) return true
      return false
    },
    signOut () {
      this.$store.commit('user', null)
      this.$store.commit('business', null)
      document.body.style.backgroundColor = '#1e1e1e'
      this.$root.$destroy()
      removeToken()
      this.$router.push('/')
      loadModule('main')
      // loadModule('main', 'redirect')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";

.menu-business {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: linear-gradient(50deg, $primary-color 0%, $secondary-color 100%);
  box-shadow: 0 1px 5px 0 rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.12);
  color: #ffffff;
  z-index: 9;
  // padding: 10px 0 10px;
  padding-bottom: 10px;
  transition: height 0.3s;
  overflow-y: hidden;
  height: $menu-height;

  &.open {
    height: 100%;
  }
}

.menu-header {
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: $menu-height;
  padding: 0 15px;
}

.menu-logo {
  cursor: pointer;
  // text-align: center;
  img {
    width: auto;
    height: 20px;
  }
}

.menu-icon {
  width: 30px;
  height: 30px;
  padding: 5px;
  cursor: pointer;
  text-align: right;
  i {
    font-size: 20px;
    line-height: 30px;
  }
}

.menu-items {
  flex-grow: 1;
}

.menu-item {
  font-size: 1.1em;
  font-weight: normal;
  padding: 8px 15px;
  cursor: pointer;
  i {
    width: 20px;
    text-align: center;
    margin-right: 10px;
  }
  &:hover {
    background-color: rgba(0, 0, 0, 0.20);
  }
  &.active {
    background-color: rgba(0, 0, 0, 0.10);
  }
}

@media screen and (min-width: $desktop-width) {
  .menu-business {
    width: $menu-width-open;
    height: 100%;
  }
  .menu-logo {
    flex-grow: 1;
  }
  .menu-icon {
    display: none;
  }
}

@media print {
  .menu-business {
    display: none;
  }
}
</style>
